module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av31-206d12d5a373d011e6f3fce2c39e92ac.jpg";